import React from 'react';
import { Link } from 'react-router-dom';
import { Sun, Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

export const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Savings Calculator', path: '/savings-calculator' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  const solutions = [
    { name: 'Residential Solar', path: '/solutions/residential-solar' },
    { name: 'Commercial Solar', path: '/solutions/commercial-solar' },
    { name: 'Housing Society Solar', path: '/solutions/housing-society-solar' },
    { name: 'On-Grid Solar', path: '/solutions/on-grid-solar' },
    { name: 'Off-Grid Solar', path: '/solutions/off-grid-solar' },
  ];

  return (
    <footer className="bg-stone-50 text-stone-900" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src={process.env.PUBLIC_URL + '/Amigos Solar Logo.png'}
                alt="Amigos Solar"
                className="h-16 object-contain"
              />
            </div>
            <p className="text-stone-600 mb-6">
              Smarter solar for homes, societies & businesses. Powering a sustainable future.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-secondary/10 hover:bg-secondary/20 rounded-full flex items-center justify-center transition-colors text-secondary" data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-secondary/10 hover:bg-secondary/20 rounded-full flex items-center justify-center transition-colors text-secondary" data-testid="social-twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-secondary/10 hover:bg-secondary/20 rounded-full flex items-center justify-center transition-colors text-secondary" data-testid="social-linkedin">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-secondary/10 hover:bg-secondary/20 rounded-full flex items-center justify-center transition-colors text-secondary" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-heading font-semibold mb-4 text-primary">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-stone-600 hover:text-secondary transition-colors" data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-heading font-semibold mb-4 text-primary">Solutions</h3>
            <ul className="space-y-2">
              {solutions.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-stone-600 hover:text-secondary transition-colors" data-testid={`footer-solution-${link.name.toLowerCase().replace(/ /g, '-')}`}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-heading font-semibold mb-4 text-primary">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0 text-secondary" />
                <div className="flex flex-col space-y-1">
                  <a href="tel:+919966581466" className="text-stone-600 hover:text-secondary transition-colors" data-testid="footer-phone">
                    +91-9966581466
                  </a>
                  <a href="tel:+917799225246" className="text-stone-600 hover:text-secondary transition-colors">
                    +91-7799225246
                  </a>
                  <a href="tel:+918686470004" className="text-stone-600 hover:text-secondary transition-colors">
                    +91-8686470004
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0 text-secondary" />
                <a href="mailto:amigosrenewableenergy@gmail.com" className="text-stone-600 hover:text-secondary transition-colors" data-testid="footer-email">
                  amigosrenewableenergy@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0 text-secondary" />
                <span className="text-stone-600">
                  H.no.1-1-27/19/10/a, Prashanth Nagar, Fatimanagar, Warangal, Hanamkonda, Telangana, India, 506004
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-200 mt-12 pt-8 text-center text-stone-600">
          <p>&copy; {new Date().getFullYear()} AMIGOS RENEWABLE ENERGY LLP. All rights reserved. | Privacy Policy | Terms of Service</p>
        </div>
      </div>
    </footer>
  );
};